import localforage from 'localforage';
import { isUndefined } from 'lodash';
import { loginStore } from '../app/login/vuex';
import { userTokenStorageKey } from '../config';
import ability from '../app/login/ability';

const needAuth = (auth) => auth === true;

const beforeEach = async (to, from, next) => {
  const login = loginStore();
  const auth = to.meta.requiresAuth;
  const isPathAuth = to.name === 'auth';
  let hasToken = true;
  const { can } = to.meta;
  const { on } = to.meta;
  /**
  * Clears all global feedback message
  * that might be visible
  */
  // Verifica se há token no localforage
  const result = await localforage.getItem(userTokenStorageKey);
  hasToken = result !== null;
  /**
   * If route doesn't require authentication be normally accessed.
   */
  if ((isPathAuth && !hasToken) || (!needAuth(auth) && !isPathAuth)) {
    await next();
    return; // return to prevent the code from continuing in its flow
    // With this flow `else` or `else if` is not necessary
  }

  /**
   * Otherwise  if authentication is required login.
   */
  await login.checkUserToken()
    .then(async () => {
      // Verifica se há token no localforage
      hasToken = await localforage.getItem(userTokenStorageKey) != null;
      // Se não houver token, manda para tela de login
      if (!hasToken) {
        next({ name: 'auth' });
        return;
      }

      // There is a token and it is valid
      login.checkPermissions();
      // if route is '/auth' and has token, redirect to 'home'
      if (isPathAuth) {
        next({ name: 'home' });
      } else if (can && on && ability.can(can, on)) {
        next(); // else can access the route
      } else if (isUndefined(can) && isUndefined(on)) {
        next();
      } else {
        next({ name: 'access-denied' });
      }
      // next();
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error(e);
      // No token, or it is invalid
      // #16269 redirecionamento de rota acessada antes de logar
      next({ name: 'auth', query: { redirect: to.fullPath } });
    });
};

export default beforeEach;
